import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import useHelpers from 'hooks/helpers';
import { useI18n } from 'next-localization';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import { useFetchCodesTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';

const dictionaryItems = {
  sedol: 'fundCodesSedol',
  isin: 'fundCodesIsin',
  bloomberg: 'fundCodesBloomberg',
  CitiCode: 'fundCodesCiticode',
  ric: 'fundCodesRic',
  valoren: 'fundCodesValoren',
  wkn: 'fundCodesWkn',
  ShareclassLipperID: 'fundCodesLipper',
  TickerSymbol: 'fundCodesTicker',
  cusip: 'fundCodesCusip',
  APIRCode: 'fundCodesApir',
  arsn: 'fundCodesArsn',
};

const FundDetailsCodesTab = () => {
  const { getErrorDictionary } = useHelpers();
  const { t } = useI18n();
  const { shareClass, language, countryCode, correlationFundRangeId, site, fund } = usePayload();
  const { data, error, isLoading } = useFetchCodesTabDataQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
      fund,
    },
    {
      skip: !shareClass,
    }
  );

  const ComponentContent = () => {
    return (
      <table aria-label="Fund details codes tab table" className="w-100">
        <thead hidden>
          <tr>
            <th scope="col">Fund code name</th>
            <th scope="col">Fund code value</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(data.content).map(([key, value]) => (
            <tr style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }} key={key}>
              <td className="h6 w-50 py-4">{t(dictionaryItems[key])}</td>
              <td className="body-default w-50 py-4">{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <FundDetailsTabRow fullWidth className="mt-4">
      {isLoading ? (
        <FundDetailsTabSkeleton />
      ) : error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      ) : data ? (
        <ComponentContent />
      ) : (
        <div className="body-default">{t('noResultsMessage')}</div>
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsCodesTab;
